import logo from './logo.svg';
import './App.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import Tracker  from './components/Tracker';

function App() {
  return (
    <>
    
<Tracker  />
    </>
  );
}

export default App;
